var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLeaderBoardIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14.47,
    height: 14.47,
    viewBox: "0 0 14.47 14.47",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_58341",
    "data-name": "Group 58341",
    transform: "translate(0.1 -0.403)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_42251",
    "data-name": "Path 42251",
    d: "M5.391,4.21,5.123,5.776a.418.418,0,0,0,.607.441l1.406-.739,1.406.739a.418.418,0,0,0,.195.048h0a.419.419,0,0,0,.407-.511L8.879,4.21,10.016,3.1a.418.418,0,0,0-.232-.713L8.213,2.16,7.51.736a.418.418,0,0,0-.75,0l-.7,1.424-1.572.228a.418.418,0,0,0-.232.713Zm1-1.254a.418.418,0,0,0,.315-.229l.425-.862.425.862a.418.418,0,0,0,.315.229l.951.138-.688.671a.418.418,0,0,0-.12.37l.162.947L7.33,4.635a.418.418,0,0,0-.389,0l-.851.447.162-.947a.418.418,0,0,0-.12-.37l-.688-.671Zm6.338,6.95H10.941a1.527,1.527,0,0,0-.7.17V8.757A1.539,1.539,0,0,0,8.7,7.22H5.568A1.539,1.539,0,0,0,4.03,8.757v.2a1.528,1.528,0,0,0-.7-.17H1.538A1.539,1.539,0,0,0,0,10.324v4.03a.418.418,0,0,0,.418.418H13.852a.418.418,0,0,0,.418-.418V11.444A1.539,1.539,0,0,0,12.732,9.906Zm-11.9.418a.7.7,0,0,1,.7-.7H3.329a.7.7,0,0,1,.7.7v3.612H.836Zm4.03,0V8.757a.7.7,0,0,1,.7-.7H8.7a.7.7,0,0,1,.7.7v5.179H4.866Zm8.568,3.612H10.24V11.444a.7.7,0,0,1,.7-.7h1.791a.7.7,0,0,1,.7.7Zm0,0",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 0.2
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeaderBoardIcon);
export default __webpack_public_path__ + "static/media/LeaderBoardIcon.fe4bd571c5e6dc32f7700666eb9e6c13.svg";
export { ForwardRef as ReactComponent };